import React, {
  Component
} from 'react';

class Modal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      display: 'block'
    };
  }

  render() {
    if (this.props.display) {
      return (
        <div>
        <div className="modal" tabIndex="-1" role="dialog" style={this.state}>
          <div className={`modal-dialog  animated fadeInDown ${this.props.modalSize ? this.props.modalSize : 'modal-lg'}`} role="document">
            <div className="modal-content shadow-lg">
              <div className="modal-header">
                <h5 className="modal-title">{this.props.title}</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.props.close}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {this.props.children}
              </div>
              <div className={this.props.hidefooter ? 'sr-only' : "modal-footer"}>
                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.props.close}>{this.props.text_close || '关 闭'}</button>
      <button type="button" className={this.props.text_submit==='' ? 'sr-only' : 'btn btn-primary '} onClick={this.props.submit}>{this.props.text_submit || '确 定'}</button>
              </div>
            </div>
          </div>

        </div>



        <div className="modal-backdrop fade show"></div>

      </div>
      )
    } else {
      return '';
    }
  }
}

export default Modal;


// WEBPACK FOOTER //
// ./src/components/modal.js